import { API_URL } from '../config/apiConfig';

export async function markBattleOverviewModeEntered(messageKey, markSeenLocally) {
  if (!messageKey) {
    throw new Error('messageKey is required');
  }
  if (typeof markSeenLocally !== 'function') {
    throw new Error('markSeenLocally is required');
  }

  markSeenLocally(messageKey);

  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No authentication token');
  }

  const res = await fetch(`${API_URL}/tutorial/mark-seen`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ messageKey }),
  });

  if (!res.ok) {
    throw new Error(`Failed to mark battle overview mode entered: ${res.status}`);
  }
}
